import { Size } from '@lessonup/pins-shared';
import React from 'react';

export interface RectangleShapeProps {
  size: Size;
  strokeWidth: number;
  cornerRadius?: number;
}

export const RectangleShape: React.FC<RectangleShapeProps> = ({ size, strokeWidth, cornerRadius }) => {
  const x = strokeWidth / 2;
  const y = strokeWidth / 2;
  const width = size.width - strokeWidth;
  const height = size.height - strokeWidth;

  return <rect x={x} y={y} width={width} height={height} rx={cornerRadius} ry={cornerRadius} />;
};
